import axiosInstance from "../services/secureApi";
// List Users (Plain JSON)
export const getUsersApi = async ({ page = 1, pageSize = 10 } = {}) => {
  try {
    const response = await axiosInstance.post("/users/admin/list", {
      page,
      limit: pageSize,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
// Get User By ID (Plain JSON)
export const getUserByIdApi = async (id, page = 1, limit = 10) => {
  try {
    const response = await axiosInstance.get(
      `/users/admin/view/${id}?page=${page}&limit=${limit}`,
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};
// Update User Status (Encrypted)
export const updateUserStatusApi = async (userid, status) => {
  try {
    const response = await axiosInstance.put("/users/admin/changeStatus", {
      userid,
      status,
    });

    return response.data;
  } catch (error) {
    console.log("Update Status Error:", error.response?.data);
    return error.response?.data;
  }
};

export const exportUsers = async () => {
  const response = await axiosInstance.get("/admin/users/export", {
    responseType: "blob",
  });

  return response;
};
